import FilterPanelController from './filter-panel.controller';
import { FilterPanelProps } from './filter-panel.model';

const FilterPanel = (props: FilterPanelProps) => {
  return <FilterPanelController {...props} />;
};

export default FilterPanel;
